import { h, Component, ComponentChildren } from 'preact'
import Icon from '../assets'

export interface Props {
  title: string,
  children: ComponentChildren,
  wrapperClass?: string
}

interface State {
  isVisible: boolean
}

class SimpleCollapsible extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      isVisible: false
    }
  }

  render ({ title, children, wrapperClass = '' }: Props, { isVisible }: State) {
    let iconType: 'chevronUp' | 'chevronDown' = isVisible ? 'chevronUp' : 'chevronDown'
    return (
      <div className={`simple-collapsible__wrapper ${wrapperClass}`}>
        <div className='simple-collapsible__title'>
          <a className='simple-collapsible__open-button' onClick={()=>{this.setState({ isVisible: !isVisible })}}>
            <span>{title}</span>
            <Icon icon={iconType} width={20} height={16} color={'currentColor'} />
          </a>
        </div>
        <div className='simple-collapsible__children'>
          { isVisible && children }
        </div>
      </div>
    )
  }
}

export default SimpleCollapsible
